import type { ComponentProps } from 'react';

import { Col } from '@opendoor/atoms/box';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

import { BuyDirectCTA } from '../BuyDirectCTA';
import { BuyWithConfidence } from '../BuyWithConfidence';

type PropertyCTAsData = ComponentProps<typeof BuyDirectCTA>['property'] &
  Pick<MarketplaceProperty, 'shouldShowGuarantee'>;

interface PropertyCTAsProps {
  property: PropertyCTAsData;
}

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  const { isActionable, tourKind } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  return (
    <Col className="gap-12 px-0 pt-12">
      <BuyDirectCTA property={property} />
      {property.shouldShowGuarantee && <BuyWithConfidence />}
    </Col>
  );
};
